var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-content",
    [
      _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { push: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "primary" },
                    [
                      _c(
                        "v-card-title",
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "icon-space white--text",
                              attrs: { left: "" }
                            },
                            [_vm._v("group")]
                          ),
                          _vm._v(" "),
                          _c("h5", { staticClass: "title white--text" }, [
                            _vm._v("FIND GROUPS")
                          ]),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: {
                              dark: "",
                              "append-icon": "search",
                              label: "Search",
                              "single-line": "",
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.searchGroup,
                              callback: function($$v) {
                                _vm.searchGroup = $$v
                              },
                              expression: "searchGroup"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-data-table", {
                        staticClass: "secondary",
                        attrs: {
                          headers: _vm.headersGroup,
                          items: _vm.groups,
                          search: _vm.searchGroup,
                          "items-per-page-options": [
                            5,
                            15,
                            25,
                            { text: "All", value: -1 }
                          ]
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "tr",
                                  {
                                    staticClass: "clickable-row",
                                    on: {
                                      click: function($event) {
                                        return _vm.selectGroup(item.key)
                                      }
                                    }
                                  },
                                  [
                                    _c("td", [_vm._v(_vm._s(item.name))]),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(item.email))])
                                  ]
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _vm.selectedGroup
                        ? _c("v-card-text", [
                            _c("h1", { staticClass: "white--text" }, [
                              _vm._v(_vm._s(_vm.selectedGroup.name))
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedGroup
                        ? _c(
                            "v-list",
                            { attrs: { dense: "" } },
                            _vm._l(_vm.selectedGroupMembers, function(
                              item,
                              index
                            ) {
                              return _c(
                                "v-list-item",
                                { key: index },
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", {
                                        staticClass:
                                          "clickable-row dark-on-hover",
                                        domProps: { textContent: _vm._s(item) },
                                        on: {
                                          click: function($event) {
                                            return _vm.selectMemberFromEmail(
                                              item
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { push: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "primary" },
                    [
                      _c(
                        "v-card-title",
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "icon-space white--text",
                              attrs: { left: "" }
                            },
                            [_vm._v("group")]
                          ),
                          _vm._v(" "),
                          _c("h5", { staticClass: "title white--text" }, [
                            _vm._v("FIND PEOPLE")
                          ]),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: {
                              dark: "",
                              "append-icon": "search",
                              label: "Search",
                              "single-line": "",
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.searchEmail,
                              callback: function($$v) {
                                _vm.searchEmail = $$v
                              },
                              expression: "searchEmail"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-data-table", {
                        staticClass: "secondary",
                        attrs: {
                          headers: _vm.headersPerson,
                          items: _vm.activePersons,
                          search: _vm.searchEmail,
                          "items-per-page-options": [
                            5,
                            15,
                            25,
                            { text: "All", value: -1 }
                          ]
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "tr",
                                  {
                                    staticClass: "clickable-row",
                                    on: {
                                      click: function($event) {
                                        return _vm.selectMember(item.key)
                                      }
                                    }
                                  },
                                  [
                                    _c("td", [_vm._v(_vm._s(item.fName))]),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(item.lName))]),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(item.email))])
                                  ]
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _vm.selectedMember
                        ? _c("v-card-text", [
                            _c("h1", { staticClass: "white--text" }, [
                              _vm._v(_vm._s(_vm.selectedMember))
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedMember
                        ? _c(
                            "v-list",
                            { attrs: { dense: "" } },
                            _vm._l(_vm.selectedMemberships, function(
                              item,
                              index
                            ) {
                              return _c(
                                "v-list-item",
                                { key: index },
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", {
                                        staticClass:
                                          "clickable-row dark-on-hover",
                                        domProps: {
                                          textContent: _vm._s(item.name)
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.selectGroup(item.id)
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-befa09e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-befa09e2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Groups/Groups.vue
// module id = 5VcY
// module chunks = 1